<template>
    <div class="JavaModelTitle">
        <div class="tit">{{title}}</div>
        <div class="subtit">{{subTitle}}</div>
        <div class="desc">{{enTag.toUpperCase()}}</div>
    </div>
</template>

<script>
export default {
    props:{
        title:{
            default: ''
        }, 
        subTitle:{
            default: ''
        },
        enTag:{
            default: ''
        },
    },
}
</script>
<style lang='scss' scoped>
.JavaModelTitle{
    position: relative;
    width: 1180px;
    margin: 0 auto;
    margin-bottom: 50px;
    .tit{
        position: relative;
        font-size: 32px;
        font-family: PingFangSC;
        font-weight: 700;
        text-align: center;
        color: #19232B;
        // background: linear-gradient(270deg,#896af9, #1b73ff 99%);
        // background-clip: text;
        // color: transparent;
        display: inline-block;
        left: 50%;
        transform: translate(-50%);
        z-index: 2;
    }
    .subtit{
        font-family: PingFangSC;
        text-align: center;
        font-size: 18px;
        color: #616A72;
        margin-top: 22px;
    }
    .desc{
        position: absolute;
        top: -16px;
        left: 50%;
        transform: translate(-50%);
        font-size: 40px;
        font-family: DINCondensed, DINCondensed-Bold;
        font-weight: 700;
        text-align: center;
        color: #000;
        opacity: 0.07;
        line-height: 48px;
        letter-spacing: 2px;
    }
}
</style>
